import { createContext, useCallback, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import React from 'react';
import { getStoredCrustCheckboxValue } from '../helpers/storage';

export const SettingsContext = createContext();

const SettingsProvider = ({ children }) => {
  const [isCrustEnabled, setIsCrustEnabled] = useState(() => getStoredCrustCheckboxValue());
  const [areDetailsVisible, setAreDetailsVisible] = useState(false);
  const [language, setLanguage] = useState('fr');

  const handleCrustChange = useCallback((event) => setIsCrustEnabled(event.target.checked), [setIsCrustEnabled]);
  const handleDetailModeChange = useCallback((event) => setAreDetailsVisible(event.target.checked), [setAreDetailsVisible]);

  const value = useMemo(
    () => ({
      areDetailsVisible,
      isCrustEnabled,
      handleCrustChange,
      handleDetailModeChange,
      language,
      setLanguage,
    }),
    [areDetailsVisible, isCrustEnabled, handleCrustChange, handleDetailModeChange]
  );

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
};

SettingsProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default SettingsProvider;
